/* R&B product cards (Carl 4 Oct, PLP v4 on staging)
   1. Colour swatches: hovering (desktop) or tapping (touch, first tap) a colour shows that colour in the same card:
      picture, hover picture, name, price and links. A second tap, or a click with a mouse, opens the product.
   2. (Sizes in stock on hover removed 4 Oct, Carl: everyone goes to the product page, where Notify me catches missing sizes.)
      Information only, no quick add.
   3. One card per style: when more pages are added by the infinite scroll, colours of a style already shown are hidden.
   4. Product / On body: the grid shows the second picture (on the body) first. Remembered per visitor.
   5. Columns by number (4 · 3 desktop, 2 · 1 mobile) and Load more instead of the auto-loader.
   6. Mobile: a sticky bar at the bottom with Refine · 1 / 2 columns · On body. */
(function () {
  if (window.__rbPlp) return;
  window.__rbPlp = true;
  var lang = (document.documentElement.lang || 'en').slice(0, 2);
  var T = { sv: { prev: 'Föregående bild', next: 'Nästa bild', stock: 'I lager', product: 'Produkt', body: 'På modell', refine: 'Filtrera', more: 'Visa fler', showing: 'Visar {n} av {t}' }, de: { prev: 'Vorheriges Bild', next: 'Nächstes Bild', stock: 'Auf Lager', product: 'Produkt', body: 'Getragen', refine: 'Filtern', more: 'Mehr laden', showing: '{n} von {t} angezeigt' } }[lang] ||
    { prev: 'Previous picture', next: 'Next picture', stock: 'In stock', product: 'Product', body: 'On body', refine: 'Refine', more: 'Load more', showing: 'Showing {n} of {t}' };
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function card(el) { return el.closest('.card-wrapper'); }
  function path(u) { try { return new URL(u, location.href).pathname; } catch (e) { return u; } }

  function swap(link, noImg) {
    var c = card(link);
    if (!c || link.classList.contains('card-model-picker__link--active') || !link.getAttribute('data-rb-src')) return false;
    var oldPath = path((c.querySelector('.card-model-picker__link--active') || {}).href || '');
    // Carl 4 Oct: another colour shows its first picture (the pack shot), never the model picture, and only once it is
    // loaded (warmed on hover); the card's own pictures are kept and come back when the mouse leaves
    var img0 = c.querySelector('.card__media .media > img');
    if (img0 && !noImg && link.getAttribute('data-rb-src')) {
      save0(c);
      var u = sized(link.getAttribute('data-rb-src'), cardW(c)), want = link;
      warm(u).then(function () {
        if (!c.querySelector('.card-model-picker__link--active') || c.querySelector('.card-model-picker__link--active') !== want) return;
        show(img0, u);
        img0.alt = want.getAttribute('data-rb-alt') || '';
        c.classList.add('rb-sw-on');
      });
    }
    c.setAttribute('data-rb-imgs', link.getAttribute('data-rb-imgs') || '');
    c.__rbI = null;
    c.classList.remove('rb-gal-on');
    gUi(c);
    var t = c.querySelector('.card-information__title');
    if (t) t.textContent = link.getAttribute('data-rb-name');
    var vh = c.querySelector('.card__heading .visually-hidden');
    if (vh) vh.textContent = link.getAttribute('data-rb-full');
    var price = link.getAttribute('data-rb-price'), pr = c.querySelector('.card-information__price .price-item--regular');
    if (price && pr && !c.querySelector('.card-information__price .price--on-sale')) pr.textContent = price;
    var newHref = link.getAttribute('href');
    [].forEach.call(c.querySelectorAll('a[href]:not(.card-model-picker__link)'), function (a) { if (path(a.href) === oldPath) a.setAttribute('href', newHref); });
    [].forEach.call(c.querySelectorAll('.card-model-picker__link'), function (a) {
      var on = a === link;
      a.classList.toggle('card-model-picker__link--active', on);
      if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
    return true;
  }

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var l = e.target.closest && e.target.closest('.card-model-picker__link');
    if (!l) return;
    var c = card(l);
    // remember the card's own colour the first time another colour is shown, so it can come back
    if (c && !c.__rbOrig) c.__rbOrig = c.querySelector('.card-model-picker__link--active');
    swap(l);
  });
  // Carl 4 Oct: when the mouse leaves the card, it goes back to the product's own colour and its own first picture
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse') return;
    var c = e.target.closest && e.target.closest('.card-wrapper');
    if (!c || (e.relatedTarget && c.contains(e.relatedTarget))) return;
    var o = c.__rbOrig;
    c.__rbOrig = null;
    if (o && o.isConnected && !o.classList.contains('card-model-picker__link--active')) swap(o, true);
    restore0(c);
  });
  document.addEventListener('click', function (e) {
    var l = e.target.closest && e.target.closest('.card-model-picker__link');
    if (!l || e.pointerType === 'mouse' || fine) return;
    if (swap(l)) e.preventDefault(); // first tap shows the colour, the next tap opens it
  });


  /* ---------- Card gallery (Carl 4 Oct, test; theme setting "More pictures on product cards") ----------
     Mouse: thin arrows at the sides on hover. Touch: swipe. Trackpad: two-finger swipe. No picture markers (Carl 4 Oct). Pictures come from data-rb-imgs (snippets/rb-card-imgs.liquid); each one is loaded and
     decoded before it is shown, and the next one is fetched ahead, so stepping never shows a blank picture. */
  var GW = [360, 533, 750, 1000, 1500], lastCard = null, cache = {};
  function gList(c) { var s = c.getAttribute('data-rb-imgs'); return s ? s.split('|') : []; }
  function withW(u, w) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function sized(u, w) { return /[?&]width=\d+/.test(u) ? u.replace(/([?&]width=)\d+/, '$1' + w) : withW(u, w); }
  // one file per picture, at the size the card needs on this screen – so a preloaded picture is exactly the one shown
  function cardW(c) {
    var m = c.querySelector('.card__media');
    var w = (m ? m.getBoundingClientRect().width : 400) * Math.min(window.devicePixelRatio || 1, 2);
    for (var k = 0; k < GW.length; k++) if (GW[k] >= w) return GW[k];
    return GW[GW.length - 1];
  }
  function warm(u) {
    if (cache[u]) return cache[u];
    var im = new Image();
    im.decoding = 'async';
    im.src = u;
    cache[u] = im.decode ? im.decode().then(function () { return im; }, function () { return im; })
      : new Promise(function (ok) { im.onload = im.onerror = function () { ok(im); }; });
    return cache[u];
  }
  function show(img, u) { img.removeAttribute('loading'); img.removeAttribute('srcset'); img.src = u; }
  function save0(c) {
    if (c.__rb0) return;
    var img = c.querySelector('.card__media .media > img');
    if (img) c.__rb0 = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), alt: img.alt };
  }
  function restore0(c) {
    var b = c.__rb0, img = c.querySelector('.card__media .media > img');
    c.__rbI = null;
    c.classList.remove('rb-gal-on', 'rb-sw-on');
    if (b && img) { if (b.srcset) img.setAttribute('srcset', b.srcset); img.src = b.src; img.alt = b.alt; }
    c.__rb0 = null;
    paintDots(c, false);
  }
  function gIdx(c, hovering) {
    if (c.__rbI != null) return c.__rbI;
    if (c.classList.contains('rb-sw-on')) return 0;
    var body = document.documentElement.classList.contains('rb-onbody');
    var two = c.querySelectorAll('.card__media .media > img').length > 1;
    return two ? ((body ? 1 : 0) ^ (hovering && c.classList.contains('rb-mh') ? 1 : 0)) : 0; // the picture on screen right now
  }
  function warmAround(c, from, n) {
    var list = gList(c), w = cardW(c);
    for (var k = 1; k <= n && k < list.length; k++) {
      warm(sized(list[(from + k) % list.length], w));
      warm(sized(list[(from - k + list.length) % list.length], w));
    }
  }
  // Carl 4 Oct: thin arrows at the sides of the picture for mouse users (shown on hover); no marker for which picture
  // is showing. Touch: swipe the picture. Trackpad: swipe sideways with two fingers over the picture.
  var ARR = '<svg width="9" height="16" viewBox="0 0 9 16" aria-hidden="true" focusable="false"><path d="M8 1 1 8l7 7" fill="none" stroke="currentColor" stroke-width="1"/></svg>';
  function gUi(c) {
    var media = c.querySelector('.card__media'), ui = c.querySelector(':scope > .rb-gal'), many = gList(c).length > 1;
    if (!many || !fine || !media) { if (ui) ui.remove(); return many; }
    // the picture sits in a lower layer than the card's link, so the arrows live on the card and are laid over it
    if (!ui) {
      ui = document.createElement('div');
      ui.className = 'rb-gal';
      ui.innerHTML = '<button type="button" class="rb-gal__b rb-gal__b--p" data-rb-gal="-1" aria-label="' + T.prev + '">' + ARR + '</button>' +
        '<button type="button" class="rb-gal__b rb-gal__b--n" data-rb-gal="1" aria-label="' + T.next + '">' + ARR + '</button>';
      c.appendChild(ui);
    }
    var cr = c.getBoundingClientRect(), mr = media.getBoundingClientRect();
    ui.style.top = (mr.top - cr.top) + 'px';
    ui.style.left = (mr.left - cr.left) + 'px';
    ui.style.width = mr.width + 'px';
    ui.style.height = mr.height + 'px';
    return true;
  }
  /* Carl 6 Oct: on phones a thin line at the foot of the picture shows which picture is on screen (Brunello Cucinelli style).
     The line sits on the media box; its dark part is one picture wide and glides to the current one. */
  function paintDots(c) {
    if (fine || !c) return;
    var n = gList(c).length, media = c.querySelector('.card__media');
    if (n < 2 || !media) return;
    var ln = media.querySelector(':scope > .rb-gal-line');
    if (!ln) { ln = document.createElement('span'); ln.className = 'rb-gal-line'; ln.setAttribute('aria-hidden', 'true'); ln.appendChild(document.createElement('i')); media.appendChild(ln); }
    ln.style.setProperty('--n', n);
    ln.style.setProperty('--i', gIdx(c, false));
  }
  function gGo(c, dir, hovering) {
    var list = gList(c);
    if (list.length < 2) return;
    gTo(c, (gIdx(c, hovering) + dir + list.length) % list.length, hovering, dir);
  }
  function gTo(c, i, hovering, dir) {
    var list = gList(c);
    if (!list[i] || (c.__rbI === i && c.classList.contains('rb-gal-on'))) return;
    c.__rbI = i;
    var img = c.querySelector('.card__media .media > img');
    if (!img) return;
    var u = sized(list[i], cardW(c));
    save0(c);
    paintDots(c, hovering);
    warm(u).then(function () {
      if (c.__rbI !== i) return;
      show(img, u);
      img.alt = '';
      c.classList.add('rb-gal-on');
    });
    warmAround(c, i, dir ? 2 : 1);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-rb-gal]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var c = card(b);
    if (c) gGo(c, parseInt(b.getAttribute('data-rb-gal'), 10), fine);
  }, true);
  // Carl 4 Oct: the second picture and the arrows only come when the mouse is on the picture itself, not on the name,
  // price or the space under it. The card's link covers the whole card, so the picture area is worked out from the
  // pointer position (class rb-mh = mouse on the picture).
  var mhCard = null, mhQueued = false, mhX = 0, mhY = 0, mhT = null;
  function mhCheck() {
    mhQueued = false;
    var el = document.elementFromPoint(mhX, mhY), c = el && el.closest && el.closest('.card-wrapper');
    var media = c && c.querySelector('.card__media'), r = media && media.getBoundingClientRect();
    var on = !!(r && mhX >= r.left && mhX <= r.right && mhY >= r.top && mhY <= r.bottom);
    if (mhCard && (mhCard !== c || !on)) mhCard.classList.remove('rb-mh');
    mhCard = on ? c : null;
    if (on) c.classList.add('rb-mh');
  }
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType !== 'mouse') return;
    mhX = e.clientX; mhY = e.clientY;
    if (!mhQueued) { mhQueued = true; requestAnimationFrame(mhCheck); }
  }, { passive: true });
  document.addEventListener('scroll', function () { if (mhCard && !mhQueued) { mhQueued = true; requestAnimationFrame(mhCheck); } }, { passive: true });
  document.addEventListener('pointerleave', function () { if (mhCard) { mhCard.classList.remove('rb-mh'); mhCard = null; } });
  // trackpad: a sideways two-finger swipe over a card's picture steps through its pictures (one step per swipe)
  var wAcc = 0, wLock = 0, wCard = null;
  document.addEventListener('wheel', function (e) {
    if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
    var c = e.target.closest && e.target.closest('.card-wrapper[data-rb-imgs]');
    var media = c && c.querySelector('.card__media'), r = media && media.getBoundingClientRect();
    if (!r || e.clientY < r.top || e.clientY > r.bottom || gList(c).length < 2) return;
    e.preventDefault(); // keep the browser's back/forward swipe from taking over
    if (c !== wCard) { wCard = c; wAcc = 0; }
    if (Date.now() < wLock) return;
    wAcc += e.deltaX;
    if (Math.abs(wAcc) < 40) return;
    gGo(c, wAcc > 0 ? 1 : -1, fine);
    wAcc = 0;
    wLock = Date.now() + 450;
  }, { passive: false });
  // mouse on a card: fetch the next pictures and the other colours' pack shots ahead
  document.addEventListener('pointerover', function (e) {
    var c = e.target.closest && e.target.closest('.card-wrapper');
    if (!c || c === lastCard) return;
    lastCard = c;
    if (c.hasAttribute('data-rb-imgs')) { gUi(c); warmAround(c, gIdx(c, true), 2); }
    var w = cardW(c);
    [].forEach.call(c.querySelectorAll('.card-model-picker__link[data-rb-src]'), function (l) { warm(sized(l.getAttribute('data-rb-src'), w)); });
  });
  document.addEventListener('pointerleave', function () { lastCard = null; });
  // touch: swipe sideways on the picture
  var sw = null, swUntil = 0;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse') return;
    var c = e.target.closest && e.target.closest('.card-wrapper[data-rb-imgs]'), media = c && c.querySelector('.card__media');
    var r = media && media.getBoundingClientRect();
    sw = r && e.clientY >= r.top && e.clientY <= r.bottom ? { c: c, x: e.clientX, y: e.clientY } : null;
    if (sw) warmAround(c, gIdx(c, false), 1);
  }, { passive: true });
  document.addEventListener('pointerup', function (e) {
    if (!sw || e.pointerType === 'mouse') return;
    var dx = e.clientX - sw.x, dy = e.clientY - sw.y, c = sw.c;
    sw = null;
    if (Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
    swUntil = Date.now() + 450;
    gGo(c, dx < 0 ? 1 : -1, false);
  }, { passive: true });
  document.addEventListener('pointercancel', function () { sw = null; }, { passive: true });
  document.addEventListener('click', function (e) {
    if (Date.now() < swUntil && e.target.closest && e.target.closest('.card-wrapper')) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  // touch: fetch each card's next picture once it is on screen, so the first swipe is instant
  var gio = (!fine && 'IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { gio.unobserve(en.target); warmAround(en.target, gIdx(en.target, false), 1); } });
  }, { rootMargin: '200px 0px' }) : null;
  function galInit() {
    if (fine) return;
    [].forEach.call(document.querySelectorAll('.card-wrapper[data-rb-imgs]'), function (c) {
      if (c.__rbGal) return;
      c.__rbGal = true;
      if (gUi(c) && gio) gio.observe(c);
      paintDots(c);
    });
    nudgeInit();
  }

  /* Phones and tablets (Carl 5 Oct, option D): once per visit, the first card with more pictures that is fully in view
     slides a little to show its next picture and settles back – teaches the swipe without a permanent marker. */
  var nudgeDone = false, nio = null;
  function nudgeSeen(set) { try { if (set) sessionStorage.setItem('rb_plp_nudge', '1'); return sessionStorage.getItem('rb_plp_nudge') === '1'; } catch (e) { return set ? true : false; } }
  function nudgeInit() {
    if (fine || nudgeDone || nio || !('IntersectionObserver' in window) || nudgeSeen()) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    nio = new IntersectionObserver(function (entries) {
      for (var k = 0; k < entries.length; k++) {
        var en = entries[k];
        if (nudgeDone || !en.isIntersecting || en.intersectionRatio < 0.9) continue;
        nudgeDone = true; nio.disconnect();
        setTimeout(function () { nudge(en.target); }, 900);
        break;
      }
    }, { threshold: [0.9] });
    [].forEach.call(document.querySelectorAll('.card-wrapper[data-rb-imgs]'), function (c) { if (gList(c).length > 1) nio.observe(c); });
  }
  function nudge(c) {
    var box = c.querySelector('.card__media .media');
    if (!box || c.__rbI != null || !c.isConnected) return;
    var list = gList(c), next = sized(list[(gIdx(c, false) + 1) % list.length], cardW(c));
    warm(next).then(function () {
      if (c.__rbI != null) return; // the visitor started swiping meanwhile
      nudgeSeen(true);
      var im = document.createElement('img');
      im.src = next; im.alt = ''; im.setAttribute('aria-hidden', 'true');
      im.style.cssText = 'position:absolute;top:0;left:100%;width:100%;height:100%;object-fit:cover;pointer-events:none';
      box.appendChild(im);
      // Carl 6 Oct: calmer – eases out, rests a moment, eases back (about 2.6 s in all)
      var kf = [{ transform: 'none', easing: 'cubic-bezier(.45,0,.25,1)' }, { transform: 'translateX(-18%)', offset: 0.4, easing: 'linear' },
        { transform: 'translateX(-18%)', offset: 0.52, easing: 'cubic-bezier(.45,0,.25,1)' }, { transform: 'none', offset: 0.92 }, { transform: 'none' }];
      var opt = { duration: 2600 }, anims = [];
      [].forEach.call(box.querySelectorAll(':scope > img'), function (el) { if (el.animate) anims.push(el.animate(kf, opt)); });
      function done() { anims.forEach(function (a) { a.cancel(); }); if (im.parentNode) im.remove(); c.removeEventListener('pointerdown', done); }
      c.addEventListener('pointerdown', done, { passive: true });
      setTimeout(done, opt.duration + 50);
    });
  }

  /* one card per style across pages added by the infinite scroll */
  function dedupe() {
    var grid = document.getElementById('product-grid');
    if (!grid || !grid.hasAttribute('data-rb-one-per-style')) return;
    var seen = {};
    [].forEach.call(grid.querySelectorAll('li[data-rb-model]'), function (li) {
      var k = li.getAttribute('data-rb-model');
      if (!k) return;
      if (seen[k]) li.hidden = true; else seen[k] = true;
    });
  }

  /* Product / On body + columns by number (markup in snippets/facets.liquid). Replaces the old grid bundle (Carl 4 Oct). */
  var KEY = 'rb_plp_view';
  function store(v, k) { k = k || KEY; try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function setView(v) {
    document.documentElement.classList.toggle('rb-onbody', v === 'body');
    [].forEach.call(document.querySelectorAll('.rb-view button'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-view') === v ? 'true' : 'false'); });
  }
  var mqM = window.matchMedia('(max-width: 749px)');
  /* Speed (6 Oct): card pictures are fetched at the width they are shown (the snippet says 2 columns on phones, 4 on
     desktop). When the visitor picks 1 or 3 columns, tell the browser, so it fetches a sharper or a smaller file. */
  var curCols = null;
  function cardSizes() {
    var g = document.getElementById('product-grid');
    if (!g || !curCols) return;
    var vw = mqM.matches ? (curCols === '1' ? '100vw' : '50vw') : (curCols === '3' ? '33vw' : curCols === '2' ? '50vw' : '25vw');
    [].forEach.call(g.querySelectorAll('.card__media img[srcset]'), function (im) {
      if (im.getAttribute('sizes') !== vw) im.setAttribute('sizes', vw);
    });
  }
  function colsKey() { return mqM.matches ? 'rb_plp_cols_m' : 'rb_plp_cols_d'; }
  function setCols(n) {
    var g = document.getElementById('product-grid');
    if (!g) return;
    ['1', '2', '3', '4', '8'].forEach(function (k) { g.classList.remove('grid--' + k + '-columns', 'grid--' + k + '-column'); });
    g.classList.add('grid--' + n + '-columns');
    g.style.setProperty('--grid-columns', n);
    var depict = window['depict-grid-rendering-script'];
    if (depict) { if (mqM.matches) depict.dataset.columnsMobile = n; else depict.dataset.columnsDesktop = n; }
    curCols = String(n);
    cardSizes();
    [].forEach.call(document.querySelectorAll('.rb-cols button'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-cols') === String(n) ? 'true' : 'false'); });
  }
  function initCols() {
    var g0 = document.getElementById('product-grid');
    var def = mqM.matches ? '2' : ((g0 && g0.getAttribute('data-rb-cols-d')) || '4'), saved = store(undefined, colsKey());
    var ok = mqM.matches ? (saved === '1' || saved === '2') : (saved === '3' || saved === '4');
    setCols(ok ? saved : def);
  }
  function gridOpts() {
    document.addEventListener('click', function (e) {
      var v = e.target.closest && e.target.closest('.rb-view button');
      if (v) { var view = v.getAttribute('data-view'); store(view); setView(view); paintBar(); return; }
      var c = e.target.closest && e.target.closest('.rb-cols button');
      if (c) { var n = c.getAttribute('data-cols'); store(n, colsKey()); setCols(n); paintBar(); }
    });
    setView(store() || 'product');
    if (document.getElementById('product-grid')) initCols();
    if (mqM.addEventListener) mqM.addEventListener('change', initCols);
  }

  /* Load more (PLP base mockup): "Showing 16 of 33", a line, and a Load more button instead of the auto-loader */
  function loadMore() {
    var g = document.getElementById('product-grid');
    if (!g || !g.hasAttribute('data-rb-pages')) return;
    var pages = parseInt(g.getAttribute('data-rb-pages'), 10) || 1, page = parseInt(g.getAttribute('data-rb-page'), 10) || 1;
    var total = parseInt(g.getAttribute('data-rb-total'), 10) || 0;
    if (pages <= 1 || page >= pages || g.parentNode.querySelector('.rb-more')) return;
    [].forEach.call(document.querySelectorAll('.pagination-wrapper, .pagination'), function (p) { p.hidden = true; });
    var box = document.createElement('div');
    box.className = 'rb-more';
    box.innerHTML = '<p class="rb-more__t"></p><span class="rb-more__line"><i></i></span><button type="button" class="rb-more__b">' + T.more + '</button>';
    g.parentNode.insertBefore(box, g.nextSibling);
    var btn = box.querySelector('button');
    function shown() { return g.querySelectorAll('li.roseandborn-product-grid__item:not([hidden])').length; }
    function paint() {
      var n = shown();
      box.querySelector('.rb-more__t').textContent = T.showing.replace('{n}', n).replace('{t}', total);
      box.querySelector('i').style.width = Math.min(100, total ? n / total * 100 : 0) + '%';
      btn.hidden = page >= pages;
    }
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      btn.disabled = true; btn.classList.add('is-busy');
      var u = new URL(location.href);
      u.searchParams.set('page', page + 1);
      u.searchParams.set('section_id', g.getAttribute('data-rb-section'));
      fetch(u.pathname + u.search).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('#product-grid > li');
        [].forEach.call(items, function (li) {
          var n = document.importNode(li, true);
          // Carl 4 Oct: added cards showed blank for a moment (scroll-reveal) – they come in fully drawn
          [n].concat([].slice.call(n.querySelectorAll('.scroll-trigger'))).forEach(function (el) { if (el.classList.contains('scroll-trigger')) el.classList.add('scroll-trigger--cancel'); });
          g.appendChild(n);
        });
        page++;
        var first = items.length ? g.children[g.children.length - items.length] : null;
        if (first) { var a = first.querySelector('a[href]'); if (a) a.focus({ preventScroll: true }); }
      }).catch(function () {}).then(function () { btn.disabled = false; btn.classList.remove('is-busy'); paint(); });
    });
    paint();
  }

  var paintBar = function () {};
  /* Mobile: sticky bar at the bottom (Refine · 1 / 2 columns · On body), shown once the top toolbar has scrolled away */
  function mobileBar() {
    var grid = document.getElementById('product-grid');
    var refine = document.querySelector('.mobile-facets__open-wrapper');
    if (!grid || document.querySelector('.rb-plp-bar')) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var bar = document.createElement('div');
    bar.className = 'rb-plp-bar';
    bar.innerHTML = (refine ? '<button type="button" data-a="refine">' + (((refine.querySelector('.mobile-facets__open-label') || {}).textContent || '').trim() || T.refine) + '</button><i></i>' : '') +
      '<span class="rb-plp-bar__cols"><button type="button" data-a="c1" aria-label="1"><svg width="12" height="15" viewBox="0 0 12 15" aria-hidden="true"><rect x=".5" y=".5" width="11" height="14" fill="none" stroke="currentColor"/></svg></button>' +
      '<button type="button" data-a="c2" aria-label="2"><svg width="17" height="15" viewBox="0 0 17 15" aria-hidden="true"><rect x=".5" y=".5" width="7" height="14" fill="none" stroke="currentColor"/><rect x="9.5" y=".5" width="7" height="14" fill="none" stroke="currentColor"/></svg></button></span><i></i>' +
      '<button type="button" data-a="view"></button>';
    document.body.appendChild(bar);
    paintBar = paint;
    // "Refine (2)": follow the count when the theme re-renders the label after a filter change (Carl 7 Oct)
    if (refine && 'MutationObserver' in window) {
      var rb = bar.querySelector('[data-a="refine"]');
      new MutationObserver(function () {
        var t = ((refine.querySelector('.mobile-facets__open-label') || {}).textContent || '').trim();
        if (t && rb.textContent !== t) rb.textContent = t;
      }).observe(refine, { childList: true, subtree: true, characterData: true });
    }
    function paint() {
      var g = document.getElementById('product-grid');
      var one = g && g.classList.contains('grid--1-columns');
      var b1 = bar.querySelector('[data-a="c1"]'), b2 = bar.querySelector('[data-a="c2"]');
      b1.setAttribute('aria-pressed', one ? 'true' : 'false'); b2.setAttribute('aria-pressed', one ? 'false' : 'true');
      bar.querySelector('[data-a="view"]').textContent = document.documentElement.classList.contains('rb-onbody') ? T.product : T.body;
    }
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      var a = b.getAttribute('data-a');
      if (a === 'refine' && refine) refine.click();
      if (a === 'c1' || a === 'c2') { store(a.slice(1), colsKey()); setCols(a.slice(1)); }
      if (a === 'view') { var v = document.documentElement.classList.contains('rb-onbody') ? 'product' : 'body'; store(v); setView(v); }
      setTimeout(paint, 60);
    });
    var top = document.querySelector('.facets-container, .facets-wrapper, .rb-grid-opts') || grid;
    var queued = false;
    function check() {
      queued = false;
      var g = document.getElementById('product-grid'); if (!g) return;
      var foot = document.querySelector('footer, .rb-footer, .footer');
      var footIn = foot && foot.getBoundingClientRect().top < window.innerHeight - 20;
      var on = mq.matches && top.getBoundingClientRect().bottom < 0 && !footIn;
      bar.classList.toggle('is-on', on);
      document.documentElement.classList.toggle('rb-plp-bar-on', on);
    }
    addEventListener('scroll', function () { if (!queued) { queued = true; requestAnimationFrame(check); } }, { passive: true });
    addEventListener('resize', check);
    paint(); check();
  }

  function start() {
    dedupe(); gridOpts(); mobileBar(); loadMore(); galInit();
    var grid = document.getElementById('product-grid');
    if (grid && 'MutationObserver' in window) new MutationObserver(function () { dedupe(); galInit(); cardSizes(); }).observe(grid, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
